module.exports = __webpack_public_path__ + "static/media/Circle 4.7a9b1d9f.svg";